import React from 'react';
import {
    Content,
    ScreenshotContainer,
    ScreenshotImage,
    TextContainer,
    Title,
    SubTitle,
    Description,
    StoreBadge
} from './styles';
import { useTheme } from '../../hooks/useTheme';
import { appStoreURL } from '../../constants/urls';

const Home = () => {
    const isDarkMode = useTheme() === 'dark';

    return (
        <Content>
            <TextContainer>
                <Title>Poker Hands</Title>
                <SubTitle>Hand rankings at a glance.</SubTitle>
                <Description>Poker Hands is a single-screen poker hand reference. No sign-in, no clutter—just the ten hands from best to worst. See every hand from Royal Flush to High Card with example cards, short descriptions, and probabilities. No ads. No in-app purchases. One screen, one purpose.</Description>
                <a href={appStoreURL}><StoreBadge src="assets/Download_on_the_App_Store_Badge.svg" /></a>
            </TextContainer>
            <ScreenshotContainer><ScreenshotImage src={`/assets/screenshot${isDarkMode ? '_dark' : ''}.png`} /></ScreenshotContainer>
        </Content>
    )
}

export default Home;
